module.exports = __webpack_public_path__ + "img/xsbm.a4955729.jpg";